import * as React from 'react';

export default function VictoryCupShadow({
  className,
  viewBox = '0 0 144 131',
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg className={className} viewBox={viewBox} fill="none" xmlns="http://www.w3.org/2000/svg">
      <ellipse
        opacity="0.5"
        cx="72"
        cy="120.816"
        rx="65"
        ry="9.234"
        fill="url(#paint0_radial_13585_94430)"
      />
      <path
        d="M40.9609 9.67188H103.354L72.1573 56.0788L40.9609 9.67188Z"
        fill="url(#paint1_radial_13585_94430)"
      />
      <path
        d="M40.9609 102.484H103.354L72.1573 56.0775L40.9609 102.484Z"
        fill="url(#paint2_radial_13585_94430)"
      />
      <path
        d="M60.0986 9.67188H84.2145L72.1566 56.0788L60.0986 9.67188Z"
        fill="url(#paint3_radial_13585_94430)"
      />
      <path
        d="M60.0986 102.484H84.2145L72.1566 56.0775L60.0986 102.484Z"
        fill="url(#paint4_radial_13585_94430)"
      />
      <path
        d="M131.55 36.2656L100.001 112.158L72.1569 56.079L131.55 36.2656Z"
        fill="url(#paint5_radial_13585_94430)"
      />
      <path
        d="M44.3125 0L12.7634 75.892L72.1563 56.0786L44.3125 0Z"
        fill="url(#paint6_radial_13585_94430)"
      />
      <path
        d="M100.82 0.414062L131.253 76.7604L72.1573 56.0784L100.82 0.414062Z"
        fill="url(#paint7_radial_13585_94430)"
      />
      <path
        d="M13.0615 35.3945L43.4946 111.741L72.1576 56.0765L13.0615 35.3945Z"
        fill="url(#paint8_radial_13585_94430)"
      />
      <path
        d="M143.807 17.3984L143.807 94.7575L72.1576 56.078L143.807 17.3984Z"
        fill="url(#paint9_radial_13585_94430)"
      />
      <path
        d="M0.507812 17.3984L0.507808 94.7575L72.1569 56.078L0.507812 17.3984Z"
        fill="url(#paint10_radial_13585_94430)"
      />
      <path
        d="M57.001 86.5075C58.0542 84.2956 60.2856 82.8867 62.7355 82.8867H81.4394C83.8892 82.8867 86.1206 84.2956 87.1739 86.5075H57.001Z"
        fill="url(#paint11_radial_13585_94430)"
      />
      <rect
        x="51.6562"
        y="86.5039"
        width="40.8627"
        height="14.1382"
        fill="url(#paint12_radial_13585_94430)"
      />
      <rect
        width="47.4146"
        height="3.44833"
        transform="matrix(1 0 0 -1 48.3799 104.094)"
        fill="url(#paint13_radial_13585_94430)"
      />
      <path
        d="M50.4492 33.9188C50.4492 30.8176 50.7071 27.8121 51.1907 24.9531H93.1567C93.6403 27.8121 93.8982 30.8176 93.8982 33.9188C93.8982 49.7808 87.1511 63.1414 77.9638 67.1639C70.6348 70.3727 78.7665 82.8851 78.7665 82.8851H65.5809C65.5809 82.8851 73.5322 70.3686 66.3384 67.219C57.1511 63.1965 50.4492 49.7808 50.4492 33.9188Z"
        fill="url(#paint14_radial_13585_94430)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M50.5259 30.7305H39.386C38.4463 30.7305 37.6553 31.3722 37.5835 32.3092C37.5098 33.2699 37.4639 34.7129 37.5484 36.7556C37.6576 39.3927 38.061 42.9491 39.2605 46.5361C40.4605 50.1247 42.4846 53.8227 45.8848 56.625C49.0351 59.2213 53.2515 60.953 58.8093 61.2139C57.8968 60.0832 57.0429 58.8386 56.2558 57.4936C52.7489 56.9295 50.0994 55.6299 48.0779 53.9639C45.3196 51.6907 43.5938 48.6213 42.5308 45.4425C41.3254 41.8379 40.8733 37.9723 40.974 34.1788H50.4348C50.4344 34.0927 50.4342 34.0065 50.4342 33.9202C50.4342 32.8447 50.4652 31.7808 50.5259 30.7305ZM85.4405 61.2103C86.3637 60.0766 87.2278 58.8275 88.0243 57.4766C91.4793 56.9036 94.0962 55.6133 96.0976 53.9639C98.8559 51.6907 100.582 48.6213 101.645 45.4425C102.85 41.8379 103.302 37.9723 103.202 34.1788H93.8826C93.883 34.0927 93.8832 34.0065 93.8832 33.9202C93.8832 32.8447 93.8521 31.7808 93.7915 30.7305H104.789C105.729 30.7305 106.52 31.3722 106.592 32.3092C106.666 33.2699 106.712 34.7129 106.627 36.7556C106.518 39.3927 106.115 42.9491 104.915 46.5361C103.715 50.1247 101.691 53.8227 98.2907 56.625C95.1545 59.2097 90.9616 60.9376 85.4405 61.2103Z"
        fill="url(#paint15_radial_13585_94430)"
      />
      <defs>
        <radialGradient
          id="paint0_radial_13585_94430"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(72 120.816) rotate(90) scale(9.234 65)"
        >
          <stop stop-color="#7C7C7C" stop-opacity="0.4" />
          <stop offset="0.838555" stop-color="#747474" stop-opacity="0" />
        </radialGradient>
        <radialGradient
          id="paint1_radial_13585_94430"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(72.1573 56.0788) rotate(-90) scale(46.4069 77.4209)"
        >
          <stop stop-color="#FC441B" stop-opacity="0" />
          <stop offset="0.458333" stop-color="#FC441B" stop-opacity="0.4" />
          <stop offset="1" stop-color="#FF5937" stop-opacity="0" />
        </radialGradient>
        <radialGradient
          id="paint2_radial_13585_94430"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(72.1573 56.0775) rotate(90) scale(46.4069 77.4209)"
        >
          <stop stop-color="#FC441B" stop-opacity="0" />
          <stop offset="0.458333" stop-color="#FC441B" stop-opacity="0.4" />
          <stop offset="1" stop-color="#FF5937" stop-opacity="0" />
        </radialGradient>
        <radialGradient
          id="paint3_radial_13585_94430"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(72.1566 56.0788) rotate(-90) scale(46.4069 29.9244)"
        >
          <stop stop-color="#FF9D66" stop-opacity="0.7" />
          <stop offset="1" stop-color="#FF6C3E" stop-opacity="0" />
        </radialGradient>
        <radialGradient
          id="paint4_radial_13585_94430"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(72.1566 56.0775) rotate(90) scale(46.4069 29.9244)"
        >
          <stop stop-color="#FF9D66" stop-opacity="0.7" />
          <stop offset="1" stop-color="#FF6C3E" stop-opacity="0" />
        </radialGradient>
        <radialGradient
          id="paint5_radial_13585_94430"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(72.1569 56.079) rotate(22.5732) scale(47.2372 101.985)"
        >
          <stop stop-color="#FC441B" stop-opacity="0" />
          <stop offset="0.5" stop-color="#FC441B" stop-opacity="0.37" />
          <stop offset="1" stop-color="#FF5937" stop-opacity="0" />
        </radialGradient>
        <radialGradient
          id="paint6_radial_13585_94430"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(72.1563 56.0786) rotate(-157.427) scale(47.2372 101.985)"
        >
          <stop stop-color="#FC441B" stop-opacity="0" />
          <stop offset="0.5" stop-color="#FC441B" stop-opacity="0.37" />
          <stop offset="1" stop-color="#FF5937" stop-opacity="0" />
        </radialGradient>
        <radialGradient
          id="paint7_radial_13585_94430"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(72.1573 56.0784) rotate(-21.7331) scale(47.2372 101.985)"
        >
          <stop stop-color="#FC441B" stop-opacity="0" />
          <stop offset="0.364583" stop-color="#FC441B" stop-opacity="0.46" />
          <stop offset="1" stop-color="#FF5937" stop-opacity="0" />
        </radialGradient>
        <radialGradient
          id="paint8_radial_13585_94430"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(72.1576 56.0765) rotate(158.267) scale(47.2372 101.985)"
        >
          <stop stop-color="#FC441B" stop-opacity="0" />
          <stop offset="0.364583" stop-color="#FC441B" stop-opacity="0.46" />
          <stop offset="1" stop-color="#FF5937" stop-opacity="0" />
        </radialGradient>
        <radialGradient
          id="paint9_radial_13585_94430"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(72.1576 56.078) scale(71.6491 95.992)"
        >
          <stop stop-color="#FF9D66" stop-opacity="0" />
          <stop offset="0.505208" stop-color="#FF9D66" stop-opacity="0.28" />
          <stop offset="1" stop-color="#FF6C3E" stop-opacity="0" />
        </radialGradient>
        <radialGradient
          id="paint10_radial_13585_94430"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(72.1569 56.078) rotate(-180) scale(71.6491 95.992)"
        >
          <stop stop-color="#FF9D66" stop-opacity="0" />
          <stop offset="0.505208" stop-color="#FF9D66" stop-opacity="0.28" />
          <stop offset="1" stop-color="#FF6C3E" stop-opacity="0" />
        </radialGradient>
        <radialGradient
          id="paint11_radial_13585_94430"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(62.2573 83.7552) rotate(28.3918) scale(19.7775 18.4922)"
        >
          <stop stop-color="#FC441B" stop-opacity="0.7" />
          <stop offset="1" stop-color="#FF5937" stop-opacity="0" />
        </radialGradient>
        <radialGradient
          id="paint12_radial_13585_94430"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(58.7748 89.895) rotate(57.3131) scale(43.6306 44.3275)"
        >
          <stop stop-color="#FC441B" stop-opacity="0.7" />
          <stop offset="1" stop-color="#FF5937" stop-opacity="0" />
        </radialGradient>
        <radialGradient
          id="paint13_radial_13585_94430"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(16.9637 0.970189) rotate(14.2935) scale(35.9721 106.419)"
        >
          <stop stop-color="#FC441B" stop-opacity="0.7" />
          <stop offset="1" stop-color="#FF5937" stop-opacity="0" />
        </radialGradient>
        <radialGradient
          id="paint14_radial_13585_94430"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(65.5868 36.0621) rotate(65.1768) scale(56.0119 49.3107)"
        >
          <stop offset="0.0255617" stop-color="#FF782D" />
          <stop offset="0.522271" stop-color="#FF4920" stop-opacity="0.75" />
        </radialGradient>
        <radialGradient
          id="paint15_radial_13585_94430"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(58.3067 31.9788) rotate(41.0667) scale(41.9638 33.7673)"
        >
          <stop stop-color="#FF6610" />
          <stop offset="1" stop-color="#DF4320" stop-opacity="0.5" />
        </radialGradient>
      </defs>
    </svg>
  );
}
